import { HttpResponse } from '@angular/common/http';
import { environment } from 'environments/environment';
import { PASSWORD_FAIL_ERROR_CODE, PASSWORD_PROTECTED_ERROR_CODE, PASSWORD_PROTECTED_OFFICEFILES_ERROR_CODE } from './constant/commonConstant';

export class CoreUtils {
  public static arrayBufferToText(data: ArrayBuffer | null): string | null {
    if (data) {
      const decoder = new TextDecoder('utf-8');
      const uarray = new Uint8Array(data);
      const ret = decoder.decode(uarray);
      return ret;
    }
    return null;
  }

  public static getHttpResponseFilename<T>(response: HttpResponse<T>, defaultFilename?: string): string | null {
    const cd = response.headers.get('content-disposition');
    let ret = defaultFilename;

    if (cd) {
      ret = cd
        .split(';')
        .find(n => n.includes('filename='))
        ?.replace('filename=', '')
        .trim()
        .replace(/"/g, '');
    }

    if (!ret) {
      ret = 'BoardWorks';
    }

    return ret;
  }

  public static parseJsonSafe<T>(text: string): T | null {
    try {
      const ret = JSON.parse(text) as T;
      return ret;
    } catch {}

    return null;
  }

  public static newAppUrl(isApi: boolean | null, path: string, query: any = null, encode: boolean = true): string {
    const baseUrl = isApi === true ? environment.baseUrl : environment.baseUrlUI;

    return this.internalNewAppUrl(baseUrl, path, query, encode);
  }

  public static newSelfUrl(path: string, query: any = null, encode: boolean = true): string {
    return this.internalNewAppUrl(window.location.origin, path, query, encode);
  }

  private static internalNewAppUrl(url: string, path: string, query: any = null, encode: boolean = true): string {
    url = `${this.trimSlashes(url)}/${this.trimSlashes(path)}`;

    const entries = query ? Object.entries(query) : null;
    const arr: string[] = [];

    if (entries && entries.length > 0) {
      entries.forEach(([key, value]) => {
        const val = encode ? encodeURIComponent(`${value}`) : `${value}`;
        const kvp = `${key}=${val}`;
        arr.push(kvp);
      });

      const qStr = arr.join('&');
      url = `${url}?${qStr}`;
    }

    return url;
  }

  public static newGuid(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0,
        v = c == 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  public static trimSlashes(url: string, start: boolean = true, end: boolean = true): string {
    if (start && end) {
      return url.replace(/(\/+)$/g, '').replace(/^(\/+)/g, '');
    } else if (start) {
      return url.replace(/^\/+/g, '');
    } else if (end) {
      return url.replace(/\/+$/, '');
    }

    return url;
  }

  public static isAbsoluteUrl(url: string | null): boolean {
    if (url && url.length > 0) {
      try {
        const u = new URL(url);
        return true;
      } catch {}
    }

    return false;
  }

  public static getUrlPathAndQuery(url: string): string {
    if (url && url.length > 0) {
      try {
        const u = new URL(url);
        url = u.pathname + u.search;
      } catch {}

      url = '/' + this.trimSlashes(url);
    }

    return url;
  }

  public static base64urlEncode(str: string): string {
    return btoa(str).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }

  public static base64urlDecode(str: string): string {
    str = str.replace(/-/g, '+').replace(/_/g, '/');

    while (str.length % 4) {
      str += '=';
    }

    return atob(str);
  }

  public static convertBooleanToYesNo(value: boolean | string): string {
    if (value === true || value === 'true') {
      return 'Yes';
    } else if (value === false || value === 'false') {
      return 'No';
    }
    return '';
  }

  public static isPasswordProtectedError(err: any): boolean {
    return err?.error?.result?.errorCode === PASSWORD_PROTECTED_ERROR_CODE;
  }

  public static isUnSopportedPasswordFilesError(err: any): boolean {
    return err?.error?.result?.errorCode === PASSWORD_PROTECTED_ERROR_CODE || err?.error?.result?.errorCode === PASSWORD_PROTECTED_OFFICEFILES_ERROR_CODE;
  }

  public static passwordFailError(err: any): boolean {
    return err?.error?.result?.errorCode === PASSWORD_FAIL_ERROR_CODE;
  }

  public static getDuplicateFiles(documents: any[]): any[] {
    if (!documents || documents.length === 0) return [];
    let duplicates: any = [];
    let seen = new Set();
    documents.forEach((doc: any) => {
      let fName = doc.fileName || doc.name;
      if (seen.has(fName)) {
        duplicates.push(doc);
      } else {
        seen.add(fName);
      }
    });
    return duplicates;
  }
}
